import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min";
import axios from "axios";
const FileUpload = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [statusCC, setStatusCC] = useState(null);
  const [statusTF, setStatusTF] = useState(null);
  const [errorCodeCC, setErrorCodeCC] = useState(null);
  const [finalUpload, setFinalUpload] = useState(false);
  const [contactnameFirstAndLast, setContactnameFirstAndLast] = useState(null);
  const [compantNameEng, setCompantNameEng] = useState(null);
  const [compantNameChi, setCompantNameChi] = useState(null);
  const [registeredAddress, setRegisteredAddress] = useState(null);
  const [placeofincorporation, setPlaceofincorporation] = useState(null);
  const [contactname, setContactname] = useState(null);
  const [contactemailaddress, setContactemailaddress] = useState(null);
  const [bankAccountNumber, setBankAccountNumber] = useState(null);
  const [bankName, setBankName] = useState(null);
  const [bankCode, setBankCode] = useState(null);
  const [swift, setSwift] = useState(null);
  const [beneficiaryName, setBeneficiaryName] = useState(null);
  const [contactphonenumber, setContactphonenumber] = useState(null);
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState(null);

  //   TF
  const [subcontractNo, setSubcontractNo] = useState(null);
  const [subcontractno, setSubcontractno] = useState(null);
  const [errorCodeTF, setErrorCodeTF] = useState(null);
  const [contractType, setContractType] = useState(null);
  const [contractName, setContractName] = useState(null);
  const [contractDetails, setContractDetails] = useState(null);
  const [projectName, setProjectName] = useState(null);
  const [projectDetails, setProjectDetails] = useState(null);
  const [documentCertifyingNo, setDocumentCertifyingNo] = useState(null);
  const [documentCertifyingIssuedby, setDocumentCertifyingIssuedby] =
    useState(null);
  const [nameofDebtor, setNameofDebtor] = useState(null);
  const [riverchainIDNo, setRiverchainIDNo] = useState(null);
  const [nameofPurchaser, setNameofPurchaser] = useState(null);
  const [invoiceNo, setInvoiceNo] = useState(null);
  const [nameofPurchaserIfother, setNameofPurchaserIfother] = useState(null);
  const [documentCertifyingAmountHK, setDocumentCertifyingAmountHK] =
    useState(null);
  const [documentCertifyingDate, setDocumentCertifyingDate] = useState(null);
  const [invoiceAmountHK, setInvoiceAmountHK] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [discount_percentage_, setDiscount_percentage_] = useState(null);
  const [repaymentPercentage, setRepaymentPercentage] = useState(null);
  const [prepaymentAmount, setPrepaymentAmount] = useState(null);
  const [Lender_Purchaser, setLender_Purchaser] = useState(null);
  const [facilityPrepaymentLimit, setFacilityPrepaymentLimit] = useState(null);
  const [
    drawdownLimitPrepaymentPercentagepercentagePaymentApplication,
    setDrawdownLimitPrepaymentPercentagepercentagePaymentApplication,
  ] = useState(null);

  const [
    drawdownLimitPrepaymentPercentagepercentageInvoicepaymentcert,
    setDrawdownLimitPrepaymentPercentagepercentageInvoicepaymentcert,
  ] = useState(null);
  const [interestRate8_7, setInterestRate8_7] = useState(null);
  const [subContractNo_Contract1, setSubContractNo_Contract1] = useState(null);
  const [contractType_Contract1, setContractType_Contract1] = useState(null);
  const [
    mainContractDescriptionContract1,
    setMainContractDescriptionContract1,
  ] = useState(null);
  const [subcontractProjectDetails1, setSubcontractProjectDetails1] =
    useState(null);
  const [receivableType01, setReceivableType01] = useState(null);
  const [receivableNo_01, setReceivableNo_01] = useState(null);
  const [applicationDate_01, setApplicationDate_01] = useState(null);
  const [applicationValue_01, setApplicationValue_01] = useState(null);
  const [certificateNo_01, setCertificateNo_01] = useState(null);
  const [certificateIssueby_01, setCertificateIssueby_01] = useState(null);
  const [certificateDate_01, setCertificateDate_01] = useState(null);
  const [certificateValue_01, setCertificateValue_01] = useState(null);
  const [mainContractor, setMainContractor] = useState(null);
  const [product_type, setProduct_type] = useState(null);
  const [transactionID, setTransactionID] = useState(null);

  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState(""); // success, danger, warning, info
  const [fileInputKey2, setFileInputKey2] = useState(0);

  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const hasVerifiedRef = useRef(false);

  const BACKEND_URL = "https://uat.atlas.docauto.riverchain.xyz";
  const API_URL = "https://uat.atlas.docauto.riverchain.xyz/api";

  const resetAll = () => {
    setFile(null);
    setFile2(null);
    setStatus(null);
    setStatusTF(null);

    setFinalUpload(false);
    setProduct_type("");
    setAlertMsg(null);
    setAlertType("");
    setLoading(false);

    // clear file inputs
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (fileInputRef2.current) fileInputRef2.current.value = "";
  };

  useEffect(() => {
    console.log("STATE UPDATED:", product_type);
  }, [product_type]);

  function formatDate(dateStr) {
    if (!dateStr) {
      return "Invalid date"; // Handle null, undefined, or empty string
    }

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const parts = dateStr.split("-");
    if (parts.length !== 3) {
      return "Invalid date format"; // Handle incorrect format
    }

    const [year, month, day] = parts;
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return "Invalid date values"; // Ensure all parts are numbers
    }

    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  }

  function formatNumber(value) {
    if (!value || isNaN(value)) return "Invalid Number";

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }
  const formatDateDDMMMYYY = (input) => {
    if (!input) return "";
    const date = new Date(input);

    if (isNaN(date)) return ""; // invalid date protection

    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const convertRate = (value) => {
    if (value == null || value === "") return "";
    const cleaned = Number(String(value).replace("%", ""));
    return (cleaned * 100).toFixed(2);
  };

  const handleUploadCC = async () => {
    try {
      if (!file) {
        console.error("First file is missing!");
        setStatus("Please select the first file.");
        return false;
      }

      const formData1 = new FormData();
      formData1.append("file", file);

      console.log("Uploading first file...1");
      const response = await fetch(`${BACKEND_URL}/uploadfile/`, {
        method: "POST",
        body: formData1,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("First file uploaded successfully:", data);

      setBankAccountNumber(data.content?.BankAccountNumber ?? "");
      setBankName(data.content?.BankName != null ? data.content?.BankName : "");
      setBankCode(data.content?.BankCode != null ? data.content?.BankCode : "");
      setSwift(data.content?.SWIFT != null ? data.content?.SWIFT : "");
      setBeneficiaryName(data.content?.BeneficiaryName ?? "");
      setCompantNameEng(data.content?.CompanyName_English ?? "");
      setCompantNameChi(data.content?.CompanyName_Chinese ?? "");
      setPlaceofincorporation(data.content?.Placeofincorporation ?? "");
      setRegisteredAddress(data.content?.RegisteredAddress ?? "");
      setContactname(data.content?.Contactname ?? "");
      const fullName = data.content?.Contactname ?? "";
      const parts = fullName.trim().split(/\s+/);
      const firstName = parts[0] ?? "";
      const lastName = parts.length > 1 ? parts[parts.length - 1] : "";
      setContactnameFirstAndLast(`${firstName} ${lastName}`.trim());

      setContactemailaddress(data.content?.Contactemailaddress ?? "");
      setContactphonenumber(data.content?.Contactphonenumber ?? "");
      setBusinessRegistrationNumber(
        data.content?.BusinessRegistrationNumber ?? ""
      );
      setErrorCodeCC(data.content?.status);
      return true;
    } catch (error) {
      console.error("Error uploading first file:", error);
      setStatus("Error uploading first file. Check console for details.");
      return false;
    }
  };

  const handleUploadTF = async () => {
    try {
      if (!file2) {
        console.error("Second file is missing!");
        setStatus("Please select the second file.");
        return;
      }
      const formData2 = new FormData();
      formData2.append("file", file2);

      console.log("Uploading second file...1");
      const response = await fetch(`${BACKEND_URL}/uploadTFfile/`, {
        method: "POST",
        body: formData2,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("Second file uploaded successfully:", data);
      setContractType(data.content?.ContractType ?? "");
      setContractName(data.content?.ContractName ?? "");
      setSubcontractNo(data.content?.Sub_contractNo ?? "");

      setSubcontractno(data.content?.Sub_contractno ?? "");

      setContractDetails(data.content?.ContractDetails ?? "");

      setProjectName(data.content?.ProjectName ?? "");

      setProjectDetails(data.content?.ProjectDetails ?? "");
      setDocumentCertifyingNo(data.content?.DocumentCertifyingNo ?? "");
      setDocumentCertifyingIssuedby(
        data.content?.DocumentCertifyingIssuedby ?? ""
      );
      setNameofDebtor(data.content?.NameofDebtor ?? "");
      setRiverchainIDNo(data.content?.RiverchainIDNo ?? "");

      setNameofPurchaserIfother(data.content?.NameofPurchaser_ifother ?? "");

      setNameofPurchaser(data.content?.NameofPurchaser ?? "");

      // DocumentOriginatingDebtNo
      setInvoiceNo(data.content?.DocumentOriginatingDebtNo ?? "");
      setDocumentCertifyingAmountHK(
        data.content?.DocumentCertifyingAmount_HK != null
          ? formatNumber(data.content?.DocumentCertifyingAmount_HK)
          : ""
      );

      setDocumentCertifyingDate(data.content?.DocumentCertifyingDate ?? "");

      // DocumentOriginatingDebtAmount_HK
      setInvoiceAmountHK(
        formatNumber(
          data.content?.DocumentOriginatingDebtAmount_HK != null &&
            data.content?.DocumentOriginatingDebtAmount_HK
        )
      );

      // DocumentOriginatingDebtDate
      setInvoiceDate(
        formatDate(
          data.content?.DocumentOriginatingDebtDate != null &&
            (data.content?.DocumentOriginatingDebtDate).split("T")[0]
        )
      );

      setDiscount_percentage_(
        (data.content?.FinalDiscount_percentage_ * 100).toFixed(2)
      );
      setRepaymentPercentage(
        (
          data.content
            ?.PrepaymentAmountasa_percentage_ofOriginalValueofReceivable * 100
        ).toFixed(2)
      );
      setPrepaymentAmount(
        formatNumber(
          data.content?.PrepaymentAmount != null &&
            data.content?.PrepaymentAmount
        )
      );
      // setStatus("Successfully uploaded the data!");
      setErrorCodeTF(data.content?.status);
      return true;
    } catch (error) {
      console.error("Error uploading second file:", error);
      setStatus("Upload failed, please check the uploaded file");
    }
  };

  const handleUploadTFVerify = async (file) => {
    try {
      // Use the file passed in, not just file2 from state
      const fileToUse = file || file2;

      if (!fileToUse) {
        console.error("Second file is missing!");
        setStatus("Please select the second file.");
        return;
      }

      const formData2 = new FormData();
      formData2.append("file", fileToUse);

      console.log("Uploading second file...2");
      const response = await fetch(
        `${BACKEND_URL}/uploadTFfileVersion8_7_productA/`,
        {
          method: "POST",
          body: formData2,
          headers: { Accept: "application/json" },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      console.log("Second file uploaded successfully-prod A-8.7-", data);

      setTransactionID(data.content?.TransactionID ?? "");

      //Use the value from response directly instead of stale state
      const value = data.content?.product_type ?? "";
      setProduct_type(value);

      // if (value === "product_B") {
      //   setStatusTF("This is a Product B file!");
      // } else {
      //   setStatusTF(null);
      // }

      setLender_Purchaser(data.content?.Lender_Purchaser ?? "");
      setFacilityPrepaymentLimit(data.content?.Facility_PrepaymentLimit ?? "");
      setDrawdownLimitPrepaymentPercentagepercentagePaymentApplication(
        data.content
          ?.DrawdownLimit_PrepaymentPercentage_percentage__PaymentApplication ??
          ""
      );
      setDrawdownLimitPrepaymentPercentagepercentageInvoicepaymentcert(
        data.content
          ?.DrawdownLimit_PrepaymentPercentage_percentage__Invoice_paymentcert ??
          ""
      );
      setInterestRate8_7(
        convertRate(data.content?.InterestRate_DiscountCharge__percentage_pa)
      );
      setSubContractNo_Contract1(data.content?.SubContractNo_Contract1 ?? "");
      setContractType_Contract1(data.content?.ContractType_Contract1 ?? "");
      setMainContractDescriptionContract1(
        data.content?.MainContractDescription_Contract1 ?? ""
      );
      setSubcontractProjectDetails1(
        data.content?.SubcontractDescription_Contract1 ?? ""
      );
      setReceivableType01(data.content?.ReceivableType_01 ?? "");
      setReceivableNo_01(data.content?.ReceivableNo_01 ?? "");
      setApplicationDate_01(
        formatDateDDMMMYYY(data.content?.ApplicationDate_01)
      );
      setApplicationValue_01(data.content?.ApplicationValue_01 ?? "");
      setCertificateNo_01(data.content?.CertificateNo_01 ?? "");
      setCertificateIssueby_01(data.content?.CertificateIssueby_01 ?? "");
      setCertificateDate_01(
        formatDateDDMMMYYY(data.content?.CertificateDate_01) // <-- you had setCertificateDate_01, likely typo
      );
      setCertificateValue_01(data.content?.CertificateValue_01 ?? "");
      setMainContractor(data.content?.MainContractor_orDebtor_Contract1 ?? "");

      return value;
    } catch (error) {
      console.error("Error uploading second file:", error);
      setStatus("Upload failed, please check the uploaded file");
    }
  };

  const handleUpload = async () => {
    // clear any old messages when user starts a fresh upload
    setStatus(null);

    if (!file || !file2) {
      setStatus("Please select both files before uploading.");
      return;
    }
    setLoading(true);
    setStatus("Uploading first file...");

    const firstFileSuccess = await handleUploadCC();

    if (firstFileSuccess) {
      console.log("First upload successful, now uploading second file...");
      setStatus("Uploading second file...");
      setFinalUpload(true);
    } else {
      console.log("First upload failed, skipping second upload.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!finalUpload) return;
    if (errorCodeCC !== "OK") return;
    const newPurchaserName =
      nameofPurchaser && nameofPurchaser === "Other LP"
        ? nameofPurchaserIfother
        : nameofPurchaser;

    const newProjectName = contractName === "" ? projectName : contractName;

    const newprojectDetails =
      contractDetails === "" ? projectDetails : contractDetails;

    const newSubcontractNo =
      subcontractno === "" ? subcontractNo : subcontractno;

    const newCertifyingDate =
      !documentCertifyingDate ||
      ["", "n/a", "N/A"].includes(documentCertifyingDate)
        ? ""
        : formatDate(documentCertifyingDate.split("T")[0]);

    if (product_type === "product_A") {
      console.log("Logged A");
      const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
<isheet recordcount="string">
	<id>0</id>
	<title>string</title>
	<description>string</description>
	<status>string</status>
	<accesstype>string</accesstype>
	<type>string</type>
	<viewlink>string</viewlink>
	<allowsections>string</allowsections>
	<allowlookup>string</allowlookup>
	<displayisheet>string</displayisheet>
	<searchasdefaultview>string</searchasdefaultview>
	<enableversion>string</enableversion>
	<enablesheetalerter>string</enablesheetalerter>
	<alertercondition>string</alertercondition>
	<overrideitemmodifieddate>string</overrideitemmodifieddate>
	<enablebulkinsertupdate>string</enablebulkinsertupdate>
	<fielddescriptions>string</fielddescriptions>
	<enablerowlocking>string</enablerowlocking>
	<setcharlimittruncatemultilinetextenabled>string</setcharlimittruncatemultilinetextenabled>
	<setcharlimittruncatemultilinetextval>string</setcharlimittruncatemultilinetextval>
	<allowchoicelistvaluesforreuse>string</allowchoicelistvaluesforreuse>
	<allowscorelistvaluesforreuse>string</allowscorelistvaluesforreuse>
	<allowIsheetComments>string</allowIsheetComments>
	<shareRecordsLimit>0</shareRecordsLimit>
	<shareRecordsLimitEnabled>0</shareRecordsLimitEnabled>
	<enableIsheetAddRecordFormSharing>string</enableIsheetAddRecordFormSharing>
	<allowViewBaseRendering>string</allowViewBaseRendering>
	<columns>
		<column sequence="string" attributecolumnid="string">
			<columnid>0</columnid>
			<name>test</name>
			<type>0</type>
			<status>0</status>
			<systemgeneratedtype>string</systemgeneratedtype>
			<section>0</section>
			<description>string</description>
			<addtodefaultview>string</addtodefaultview>
			<columnconditionstate>string</columnconditionstate>
			<columnconditions>
				<row>
					<rowid>0</rowid>
					<columnid>0</columnid>
					<operatorid>0</operatorid>
					<oprand>string</oprand>
					<logicaltype>string</logicaltype>
					<sheetfiltervaluetypeid>string</sheetfiltervaluetypeid>
					<displaytype>string</displaytype>
					<scoreConditionTypeid>0</scoreConditionTypeid>
					<sourceColumnId>0</sourceColumnId>
				</row>
			</columnconditions>
			<columnspecificdetail>
				<defaultvalue>string</defaultvalue>
				<columnwidth>string</columnwidth>
				<sheetname>string</sheetname>
				<sitename>string</sitename>
				<mandatory>string</mandatory>
				<allowsearch>string</allowsearch>
				<maxchars>0</maxchars>
				<allowfieldfromanotherisheet>string</allowfieldfromanotherisheet>
				<allowrichhtmltext>string</allowrichhtmltext>
				<numberoflines>0</numberoflines>
				<displaymethod>string</displaymethod>
				<includeotheroption>string</includeotheroption>
				<singleormultileselectioninsearch>string</singleormultileselectioninsearch>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<includeinalertpreferences>string</includeinalertpreferences>
				<min>string</min>
				<max>string</max>
				<decimalplaces>0</decimalplaces>
				<showthousandseparators>string</showthousandseparators>
				<showaspercentage>string</showaspercentage>
				<symbolId>string</symbolId>
				<numberDecimalFormat>DOT_AS_DECIMAL/COMMA_AS_DECIMAL</numberDecimalFormat>
				<symbolPosition>before/after</symbolPosition>
				<formattype>string</formattype>
				<dateformat>string</dateformat>
				<defaultdateandtime>string</defaultdateandtime>
				<sheetlookup>string</sheetlookup>
				<fielddisplay>string</fielddisplay>
				<allowmultipleusers>string</allowmultipleusers>
				<methodtype>string</methodtype>
				<sheetids>string</sheetids>
				<allowuserstorenamelinks>string</allowuserstorenamelinks>
				<sheetid>0</sheetid>
				<columnids>string</columnids>
				<viewid>0</viewid>
				<allowmultiplevalues>string</allowmultiplevalues>
				<restrictdelete>string</restrictdelete>
				<displaycolumnnameprefix>string</displaycolumnnameprefix>
				<linkname>string</linkname>
				<donotcountweekendsonlycountmontofri>string</donotcountweekendsonlycountmontofri>
				<joinconditions>
					<joincondition>
						<currentsheetcolumnid>0</currentsheetcolumnid>
						<targetsheetcolumnid>0</targetsheetcolumnid>
					</joincondition>
				</joinconditions>
				<formula>string</formula>
				<startvalue>0</startvalue>
				<prefix>string</prefix>
				<postfix>string</postfix>
				<minlength>0</minlength>
				<lookupglossarysheetid>0</lookupglossarysheetid>
				<lookupglossarysheetviewid>0</lookupglossarysheetviewid>
				<width>0</width>
				<otherscorevalue>string</otherscorevalue>
				<importdatafromexternalsource>string</importdatafromexternalsource>
				<analysisengine>string</analysisengine>
				<attachmentcustomfolderid/>
				<singleLineEmailValidation>string</singleLineEmailValidation>
				<readonly>string</readonly>
				<virtualColumn>0</virtualColumn>
				<externalSource>string</externalSource>
				<allowInlineEditing>string</allowInlineEditing>
			</columnspecificdetail>
			<rawdata>
				<value>string</value>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<date>string</date>
				<time>string</time>
				<linkdisplayname>string</linkdisplayname>
				<linkdisplayurl>string</linkdisplayurl>
				<lookups>
					<lookup>
						<id>string</id>
						<email>string</email>
						<userlookuptype>string</userlookuptype>
					</lookup>
				</lookups>
				<folders>
					<folder>
						<folderid>string</folderid>
					</folder>
				</folders>
				<documents>
					<document>
						<docid>string</docid>
					</document>
				</documents>
				<fromdate>string</fromdate>
				<todate>string</todate>
				<attachments>
					<attachment>
						<file>string</file>
						<name>string</name>
						<order>string</order>
						<id>0</id>
						<extension>string</extension>
						<parentfolderid>0</parentfolderid>
						<filehttplink>string</filehttplink>
						<folderpath>string</folderpath>
						<folderhttplink>string</folderhttplink>
						<filesize>0</filesize>
						<redactionstatus>true</redactionstatus>
						<siteid>0</siteid>
						<displayname>string</displayname>
					</attachment>
				</attachments>
				<isheetitems>
					<isheetitem>
						<recordid>string</recordid>
						<linkname>string</linkname>
						<apilink>string</apilink>
						<httplink>string</httplink>
					</isheetitem>
				</isheetitems>
				<daydifference>string</daydifference>
			</rawdata>
			<colViewPosition>0</colViewPosition>
			<columntype>string</columntype>
			<createdDate>2025-11-29T08:36:56.328Z</createdDate>
			<modifiedDate>2025-11-29T08:36:56.328Z</modifiedDate>
			<injectReferenceColumn>0</injectReferenceColumn>
			<parentColumnID>0</parentColumnID>
			<reusecolumnidfromisheet>0</reusecolumnidfromisheet>
			<choicelistid>0</choicelistid>
			<editpermission>0</editpermission>
			<templatesheetcolumnid>0</templatesheetcolumnid>
			<uploadpermission>0</uploadpermission>
			<deletepermission>0</deletepermission>
			<sourceSheetID>0</sourceSheetID>
		</column>
	</columns>
	<metadata>
		<viewName>string</viewName>
		<siteId>0</siteId>
		<sheetName>string</sheetName>
		<siteName>string</siteName>
		<sheetId>0</sheetId>
		<viewId>0</viewId>
	</metadata>
	<head>
      <headcolumn sequence="1" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="2555">
        <columnvalue><![CDATA[Created by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="2" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2556">
        <columnvalue><![CDATA[Created date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="3" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="2557">
        <columnvalue><![CDATA[Modified by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="4" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2558">
        <columnvalue><![CDATA[Modified date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="5" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2573">
        <columnvalue><![CDATA[Riverchain ID]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="6" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2559">
        <columnvalue><![CDATA[Client Name English]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="7" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2560">
        <columnvalue><![CDATA[Client Name Chinese]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="8" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2587">
        <columnvalue><![CDATA[Purchaser Company Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="9" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2574">
        <columnvalue><![CDATA[Purchaser Signor Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="10" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2575">
        <columnvalue><![CDATA[Purchaser Signor Title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="11" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2576">
        <columnvalue><![CDATA[Purchaser BR No. (Riverchain International)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="12" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2577">
        <columnvalue><![CDATA[Purchaser BR No. (AR Horizon)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="13" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2561">
        <columnvalue><![CDATA[Client place of incorporation]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="14" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="2562">
        <columnvalue><![CDATA[Client Address]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="15" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2563">
        <columnvalue><![CDATA[Client Contact Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="16" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2564">
        <columnvalue><![CDATA[Client Contact Email]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="17" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2565">
        <columnvalue><![CDATA[Receivable subcontract No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="18" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2566">
        <columnvalue><![CDATA[Contract Type]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="19" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2567">
        <columnvalue><![CDATA[Project Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="20" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="2568">
        <columnvalue><![CDATA[Project Details]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="21" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2569">
        <columnvalue><![CDATA[Invoice No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="22" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2570">
        <columnvalue><![CDATA[Certificate No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="23" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2571">
        <columnvalue><![CDATA[Certificate Issue by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="24" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2581">
        <columnvalue><![CDATA[Client BR No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="25" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2582">
        <columnvalue><![CDATA[Client Contact No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="26" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2588">
        <columnvalue><![CDATA[Receivable Type]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="27" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2589">
        <columnvalue><![CDATA[Receivable Certificate Type]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="28" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2590">
        <columnvalue><![CDATA[Seller Account No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="29" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2591">
        <columnvalue><![CDATA[Seller Bank Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="30" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2592">
        <columnvalue><![CDATA[Seller Bank Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="31" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2593">
        <columnvalue><![CDATA[Seller Bank Swift Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="32" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2594">
        <columnvalue><![CDATA[Seller Bank Account Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="33" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2572">
        <columnvalue><![CDATA[Debtor Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="34" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="2596">
        <columnvalue><![CDATA[Purchaser BR No. (Riverchain One)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="35" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2597">
        <columnvalue><![CDATA[Purchaser Prepayment Amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="36" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2598">
        <columnvalue><![CDATA[Purchaser Prepayment Percentage (Invoice/Payment Cert)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="37" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2599">
        <columnvalue><![CDATA[Purchaser Prepayment Percentage (Payment Application)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="38" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2600">
        <columnvalue><![CDATA[Purchaser discount percentage]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="39" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2601">
        <columnvalue><![CDATA[Invoice Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="40" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2602">
        <columnvalue><![CDATA[Invoice amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="41" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="2603">
        <columnvalue><![CDATA[Certificate Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="42" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2604">
        <columnvalue><![CDATA[Certificate Amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="43" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="2605">
        <columnvalue><![CDATA[Riverchain Rebate]]></columnvalue>
      </headcolumn>
    </head>
	<data>
		<item externalid="" itemsequence="1" itemid="1">
        <column sequence="5" attributecolumnid="2573">
          <rawdata>
            <value><![CDATA[${transactionID}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${transactionID}]]></value>
          </displaydata>
        </column>
        <column sequence="6" attributecolumnid="2559">
            <rawdata>
                <value><![CDATA[${compantNameEng}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${compantNameEng}]]></value>
            </displaydata>
        </column>
        <column sequence="7" attributecolumnid="2560">
            <rawdata>
                <value><![CDATA[${compantNameChi}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${compantNameChi}]]></value>
            </displaydata>
        </column>
         <column sequence="8" attributecolumnid="2587">
            <rawdata>
                <value><![CDATA[${Lender_Purchaser}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${Lender_Purchaser}]]></value>
            </displaydata>
        </column>
        <column sequence="13" attributecolumnid="2561">
            <rawdata>
                <value><![CDATA[${placeofincorporation}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${placeofincorporation}]]></value>
            </displaydata>
        </column>
         <column sequence="14" attributecolumnid="2562">
            <rawdata>
                <value><![CDATA[${registeredAddress}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${registeredAddress}]]></value>
            </displaydata>
        </column>
        <column sequence="15" attributecolumnid="2563">
            <rawdata>
                <value><![CDATA[${contactnameFirstAndLast}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${contactnameFirstAndLast}]]></value>
            </displaydata>
        </column>
        <column sequence="16" attributecolumnid="2564">
            <rawdata>
                <value><![CDATA[${contactemailaddress}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${contactemailaddress}]]></value>
            </displaydata>
        </column>
        <column sequence="17" attributecolumnid="2565">
            <rawdata>
                <value><![CDATA[${subContractNo_Contract1}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${subContractNo_Contract1}]]></value>
            </displaydata>
        </column>
        <column sequence="18" attributecolumnid="2566">
            <rawdata>
                <value><![CDATA[${contractType_Contract1}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${contractType_Contract1}]]></value>
            </displaydata>
        </column>
        <column sequence="19" attributecolumnid="2567">
            <rawdata>
                <value><![CDATA[${mainContractDescriptionContract1}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${mainContractDescriptionContract1}]]></value>
            </displaydata>
        </column>
        <column sequence="20" attributecolumnid="2568">
            <rawdata>
                <value><![CDATA[${subcontractProjectDetails1}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${subcontractProjectDetails1}]]></value>
            </displaydata>
        </column>
         <column sequence="21" attributecolumnid="2569">
            <rawdata>
                <value><![CDATA[${receivableNo_01}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${receivableNo_01}]]></value>
            </displaydata>
        </column>
        <column sequence="22" attributecolumnid="2570">
            <rawdata>
                <value><![CDATA[${certificateNo_01}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${certificateNo_01}]]></value>
            </displaydata>
        </column>
        <column sequence="23" attributecolumnid="2571">
            <rawdata>
                <value><![CDATA[${certificateIssueby_01}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${certificateIssueby_01}]]></value>
            </displaydata>
        </column>
        <column sequence="24" attributecolumnid="2581">
            <rawdata>
                <value><![CDATA[${businessRegistrationNumber}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${businessRegistrationNumber}]]></value>
            </displaydata>
        </column>
        <column sequence="25" attributecolumnid="2582">
            <rawdata>
                <value><![CDATA[${contactphonenumber}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${contactphonenumber}]]></value>
            </displaydata>
        </column>
        <column sequence="26" attributecolumnid="2588">
            <rawdata>
                <value><![CDATA[${receivableType01}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${receivableType01}]]></value>
            </displaydata>
        </column>
        <column sequence="28" attributecolumnid="2590">
            <rawdata>
                <value><![CDATA[${bankAccountNumber}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${bankAccountNumber}]]></value>
            </displaydata>
        </column>
        <column sequence="29" attributecolumnid="2591">
            <rawdata>
                <value><![CDATA[${bankName}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${bankName}]]></value>
            </displaydata>
        </column>
        <column sequence="30" attributecolumnid="2592">
            <rawdata>
                <value><![CDATA[${bankCode}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${bankCode}]]></value>
            </displaydata>
        </column>
        <column sequence="31" attributecolumnid="2593">
            <rawdata>
                <value><![CDATA[${swift}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${swift}]]></value>
            </displaydata>
        </column>
        <column sequence="32" attributecolumnid="2594">
            <rawdata>
                <value><![CDATA[${beneficiaryName}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${beneficiaryName}]]></value>
            </displaydata>
        </column>
        <column sequence="33" attributecolumnid="2572">
            <rawdata>
                <value><![CDATA[${mainContractor}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${mainContractor}]]></value>
            </displaydata>
        </column>
        <column sequence="35" attributecolumnid="2597">
            <rawdata>
                <value><![CDATA[${facilityPrepaymentLimit}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${facilityPrepaymentLimit}]]></value>
            </displaydata>
        </column>
        <column sequence="36" attributecolumnid="2598">
            <rawdata>
                <value><![CDATA[${drawdownLimitPrepaymentPercentagepercentageInvoicepaymentcert}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${drawdownLimitPrepaymentPercentagepercentageInvoicepaymentcert}]]></value>
            </displaydata>
        </column>
        <column sequence="37" attributecolumnid="2599">
            <rawdata>
                <value><![CDATA[${drawdownLimitPrepaymentPercentagepercentagePaymentApplication}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${drawdownLimitPrepaymentPercentagepercentagePaymentApplication}]]></value>
            </displaydata>
        </column>
        <column sequence="38" attributecolumnid="2600">
            <rawdata>
                <value><![CDATA[${interestRate8_7}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${interestRate8_7}]]></value>
            </displaydata>
        </column>
         <column sequence="39" attributecolumnid="2601">
            <rawdata>
                <value><![CDATA[${applicationDate_01}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${applicationDate_01}]]></value>
            </displaydata>
        </column>
        <column sequence="40" attributecolumnid="2602">
            <rawdata>
                <value><![CDATA[${applicationValue_01}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${applicationValue_01}]]></value>
            </displaydata>
        </column>
        <column sequence="41" attributecolumnid="2603">
            <rawdata>
                <value><![CDATA[${certificateDate_01}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${certificateDate_01}]]></value>
            </displaydata>
        </column>
        <column sequence="42" attributecolumnid="2604">
            <rawdata>
                <value><![CDATA[${certificateValue_01}]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[${certificateValue_01}]]></value>
            </displaydata>
        </column>
        <column sequence="43" attributecolumnid="2605">
            <rawdata>
                <value><![CDATA[]]></value>
            </rawdata>
            <displaydata>
                <value><![CDATA[]]></value>
            </displaydata>
        </column>
		</item>
	</data>
	<sheettypeid>0</sheettypeid>
	<enablesmartform>string</enablesmartform>
	<allowDeletedItemsView>string</allowDeletedItemsView>
	<allowAllColumnsInCustomView>string</allowAllColumnsInCustomView>
</isheet>`;

      const postProductADataA8_7 = async () => {
        try {
          const res = await axios.post(`${API_URL}/postProdALoan8_7`, xmlData, {
            headers: {
              "Content-Type": "application/xml",
            },
          });

          console.log("Response_data:", res.data.progressivekey);

          const progressiveKey = res.data.progressivekey;
          // start here
          const response = await axios.post(
            `${BACKEND_URL}/getHighQResponse/${progressiveKey}`
          );
          console.log("Response_data_progresskey:", response.data);
          const msg = response.data?.[0]?.columns?.[0]?.message;

          //ONE place to set success status
          setStatus(msg || "iSheet successfully generated");

          onUploadSuccess(); // if you need to refresh list, etc.
          setTimeout(() => {
            resetAll();
          }, 2000);
        } catch (error) {
          console.error("Error sending data:", error);
        }
      };
      postProductADataA8_7();
    }

    if (product_type === "") {
      const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
                          <isheet recordcount="string">
                            <id>0</id>
                            <title>string</title>
                            <description>string</description>
                            <status>string</status>
                            <accesstype>string</accesstype>
                            <type>string</type>
                            <viewlink>string</viewlink>
                            <allowsections>string</allowsections>
                            <allowlookup>string</allowlookup>
                            <displayisheet>string</displayisheet>
                            <searchasdefaultview>string</searchasdefaultview>
                            <enableversion>string</enableversion>
                            <enablesheetalerter>string</enablesheetalerter>
                            <alertercondition>string</alertercondition>
                            <overrideitemmodifieddate>string</overrideitemmodifieddate>
                            <enablebulkinsertupdate>string</enablebulkinsertupdate>
                            <fielddescriptions>string</fielddescriptions>
                            <enablerowlocking>string</enablerowlocking>
                            <setcharlimittruncatemultilinetextenabled>string</setcharlimittruncatemultilinetextenabled>
                            <setcharlimittruncatemultilinetextval>string</setcharlimittruncatemultilinetextval>
                            <allowchoicelistvaluesforreuse>string</allowchoicelistvaluesforreuse>
                            <allowscorelistvaluesforreuse>string</allowscorelistvaluesforreuse>
                            <allowIsheetComments>string</allowIsheetComments>
                            <shareRecordsLimit>0</shareRecordsLimit>
                            <shareRecordsLimitEnabled>0</shareRecordsLimitEnabled>
                            <enableIsheetAddRecordFormSharing>string</enableIsheetAddRecordFormSharing>
                            <allowViewBaseRendering>string</allowViewBaseRendering>
                            <columns>
                              <column sequence="string" attributecolumnid="290">
                                <columnid>0</columnid>
                                <name>test</name>
                                <type>0</type>
                                <status>0</status>
                                <systemgeneratedtype>string</systemgeneratedtype>
                                <section>0</section>
                                <description>string</description>
                                <addtodefaultview>string</addtodefaultview>
                                <columnconditionstate>string</columnconditionstate>
                                <columnconditions>
                                  <row>
                                    <rowid>0</rowid>
                                    <columnid>0</columnid>
                                    <operatorid>0</operatorid>
                                    <oprand>string</oprand>
                                    <userlookupfilters>
                                      <userlookupfilter>
                                        <oprand>string</oprand>
                                        <userlookuptype>string</userlookuptype>
                                      </userlookupfilter>
                                    </userlookupfilters>
                                    <logicaltype>string</logicaltype>
                                    <sheetfiltervaluetypeid>string</sheetfiltervaluetypeid>
                                    <displaytype>string</displaytype>
                                    <scoreConditionTypeid>0</scoreConditionTypeid>
                                    <sourceColumnId>0</sourceColumnId>
                                  </row>
                                  </columnconditions>
                                  <columnspecificdetail>
                                    <defaultvalue>string</defaultvalue>
                                    <columnwidth>string</columnwidth>
                                    <sheetname>string</sheetname>
                                    <sitename>string</sitename>
                                    <mandatory>string</mandatory>
                                    <allowsearch>string</allowsearch>
                                    <maxchars>0</maxchars>
                                    <allowfieldfromanotherisheet>string</allowfieldfromanotherisheet>
                                    <allowrichhtmltext>string</allowrichhtmltext>
                                    <numberoflines>0</numberoflines>
                                    <displaymethod>string</displaymethod>
                                    <includeotheroption>string</includeotheroption>
                                    <singleormultileselectioninsearch>string</singleormultileselectioninsearch>
                                    <choices>
                                      <choice>
                                        <id>string</id>
                                        <label>string</label>
                                        <score>string</score>
                                        <color>string</color>
                                        <imageid>0</imageid>
                                      </choice>
                                    </choices>
                                    <includeinalertpreferences>string</includeinalertpreferences>
                                    <min>string</min>
                                    <max>string</max>
                                    <decimalplaces>0</decimalplaces>
                                    <showthousandseparators>string</showthousandseparators>
                                    <showaspercentage>string</showaspercentage>
                                    <symbolId>string</symbolId>
                                    <numberDecimalFormat>DOT_AS_DECIMAL/COMMA_AS_DECIMAL</numberDecimalFormat>
                                    <symbolPosition>before/after</symbolPosition>
                                    <formattype>string</formattype>
                                    <dateformat>string</dateformat>
                                    <defaultdateandtime>string</defaultdateandtime>
                                    <sheetlookup>string</sheetlookup>
                                    <fielddisplay>string</fielddisplay>
                                    <allowmultipleusers>string</allowmultipleusers>
                                    <methodtype>string</methodtype>
                                    <sheetids>string</sheetids>
                                    <allowuserstorenamelinks>string</allowuserstorenamelinks>
                                    <sheetid>0</sheetid>
                                    <columnids>string</columnids>
                                    <viewid>0</viewid>
                                    <allowmultiplevalues>string</allowmultiplevalues>
                                    <restrictdelete>string</restrictdelete>
                                    <displaycolumnnameprefix>string</displaycolumnnameprefix>
                                    <linkname>string</linkname>
                                    <donotcountweekendsonlycountmontofri>string</donotcountweekendsonlycountmontofri>
                                    <joinconditions>
                                      <joincondition>
                                        <currentsheetcolumnid>0</currentsheetcolumnid>
                                        <targetsheetcolumnid>0</targetsheetcolumnid>
                                      </joincondition>
                                    </joinconditions>
                                    <formula>string</formula>
                                    <startvalue>0</startvalue>
                                    <prefix>string</prefix>
                                    <postfix>string</postfix>
                                    <minlength>0</minlength>
                                    <lookupglossarysheetid>0</lookupglossarysheetid>
                                    <lookupglossarysheetviewid>0</lookupglossarysheetviewid>
                                    <width>0</width>
                                    <otherscorevalue>string</otherscorevalue>
                                    <importdatafromexternalsource>string</importdatafromexternalsource>
                                    <analysisengine>string</analysisengine>
                                    <attachmentcustomfolderid>0</attachmentcustomfolderid>
                                    <singleLineEmailValidation>string</singleLineEmailValidation>
                                    <readonly>string</readonly>
                                    <virtualColumn>0</virtualColumn>
                                    <externalSource>string</externalSource>
                                    <allowInlineEditing>string</allowInlineEditing>
                                  </columnspecificdetail>
                                  <rawdata>
                                  <value>string</value>
                                  <choices>
                                    <choice>
                                      <id>string</id>
                                      <label>string</label>
                                      <score>string</score>
                                      <color>string</color>
                                      <imageid>0</imageid>
                                    </choice>
                                  </choices>
                                  <date>string</date>
                                  <time>string</time>
                                  <linkdisplayname>string</linkdisplayname>
                                  <linkdisplayurl>string</linkdisplayurl>
                                  <lookups>
                                    <lookup>
                                      <id>string</id>
                                      <email>string</email>
                                      <userlookuptype>string</userlookuptype>
                                    </lookup>
                                  </lookups>
                                  <folders>
                                    <folder>
                                      <folderid>string</folderid>
                                    </folder>
                                  </folders>
                                  <documents>
                                    <document>
                                      <docid>string</docid>
                                    </document>
                                  </documents>
                                  <fromdate>string</fromdate>
                                  <todate>string</todate>
                                  <attachments>
                                    <attachment>
                                      <file>string</file>
                                      <name>string</name>
                                      <order>string</order>
                                      <id>0</id>
                                      <extension>string</extension>
                                      <parentfolderid>0</parentfolderid>
                                      <filehttplink>string</filehttplink>
                                      <folderpath>string</folderpath>
                                      <folderhttplink>string</folderhttplink>
                                      <filesize>0</filesize>
                                      <redactionstatus>true</redactionstatus>
                                      <siteid>0</siteid>
                                      <displayname>string</displayname>
                                    </attachment>
                                  </attachments>
                                  <isheetitems>
                                    <isheetitem>
                                      <recordid>string</recordid>
                                      <linkname>string</linkname>
                                      <apilink>string</apilink>
                                      <httplink>string</httplink>
                                    </isheetitem>
                                  </isheetitems>
                                  <daydifference>string</daydifference>
                                </rawdata>
                                <colViewPosition>0</colViewPosition>
                                <columntype>string</columntype>
                                <createdDate>2025-02-17T09:13:44.900Z</createdDate>
                                <modifiedDate>2025-02-17T09:13:44.900Z</modifiedDate>
                                <injectReferenceColumn>0</injectReferenceColumn>
                                <parentColumnID>0</parentColumnID>
                                <reusecolumnidfromisheet>0</reusecolumnidfromisheet>
                                <choicelistid>0</choicelistid>
                                <editpermission>0</editpermission>
                                <templatesheetcolumnid>0</templatesheetcolumnid>
                                <uploadpermission>0</uploadpermission>
                                <deletepermission>0</deletepermission>
                                <sourceSheetID>0</sourceSheetID>
                              </column>
                            </columns>
                            <metadata>
                              <siteName>string</siteName>
                              <siteId>0</siteId>
                              <sheetId>0</sheetId>
                              <viewId>0</viewId>
                              <viewName>string</viewName>
                              <sheetName>string</sheetName>
                            </metadata>
                                <head>
                                <headcolumn sequence="5" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="835">
                                  <columnvalue><![CDATA[Riverchain ID]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="6" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="821">
                                  <columnvalue><![CDATA[Client Name English]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="7" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="822">
                                  <columnvalue><![CDATA[Client Name Chinese]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="8" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="849">
                                  <columnvalue><![CDATA[Purchaser Company Name]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="9" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="836">
                                  <columnvalue><![CDATA[Purchaser Signor Name]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="10" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="837">
                                  <columnvalue><![CDATA[Purchaser Signor Title]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="11" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="838">
                                  <columnvalue><![CDATA[Purchaser BR No. (Riverchain International)]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="12" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="839">
                                  <columnvalue><![CDATA[Purchaser BR No. (AR Horizon)]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="13" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="840">
                                  <columnvalue><![CDATA[Purchaser Prepayment Amount]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="14" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="841">
                                  <columnvalue><![CDATA[Purchaser Prepayment Percentage]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="15" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="842">
                                  <columnvalue><![CDATA[Purchaser discount percentage]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="16" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="823">
                                  <columnvalue><![CDATA[Client place of incorporation]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="17" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="824">
                                  <columnvalue><![CDATA[Client Address]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="18" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="825">
                                  <columnvalue><![CDATA[Client Contact Name]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="19" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="826">
                                  <columnvalue><![CDATA[Client Contact Email]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="20" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="827">
                                  <columnvalue><![CDATA[Receivable subcontract No.]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="21" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="828">
                                  <columnvalue><![CDATA[Contract Type]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="22" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="829">
                                  <columnvalue><![CDATA[Project Name]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="23" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="830">
                                  <columnvalue><![CDATA[Project Details]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="24" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="831">
                                  <columnvalue><![CDATA[Invoice No.]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="25" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="832">
                                  <columnvalue><![CDATA[Certificate No.]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="26" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="833">
                                  <columnvalue><![CDATA[Certificate Issue by]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="27" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="843">
                                  <columnvalue><![CDATA[Client BR No.]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="28" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="844">
                                  <columnvalue><![CDATA[Client Contact No.]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="29" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="845">
                                  <columnvalue><![CDATA[Invoice Date]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="30" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="846">
                                  <columnvalue><![CDATA[Invoice amount]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="31" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="847">
                                  <columnvalue><![CDATA[Certificate Date]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="32" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="848">
                                  <columnvalue><![CDATA[Certificate Amount]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="33" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="850">
                                  <columnvalue><![CDATA[Receivable Type]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="34" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="851">
                                  <columnvalue><![CDATA[Receivable Certificate Type]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="35" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="852">
                                  <columnvalue><![CDATA[Seller Account No.]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="36" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="853">
                                  <columnvalue><![CDATA[Seller Bank Name]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="37" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="854">
                                  <columnvalue><![CDATA[Seller Bank Code]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="38" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="855">
                                  <columnvalue><![CDATA[Seller Bank Swift Code]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="49" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="856">
                                  <columnvalue><![CDATA[Seller Bank Account Name]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="40" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="834">
                                  <columnvalue><![CDATA[Debtor Name]]></columnvalue>
                                </headcolumn>
                                <headcolumn sequence="41" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="858">
                                  <columnvalue><![CDATA[Purchaser BR No. (Riverchain One)]]></columnvalue>
                                </headcolumn>
                              </head>
                            <data>
                            <item externalid="" itemsequence="1" itemid="114">
                                    <column sequence="5" attributecolumnid="835">
                                        <rawdata>
                                            <value><![CDATA[${riverchainIDNo}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${riverchainIDNo}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="6" attributecolumnid="821">
                                        <rawdata>
                                            <value><![CDATA[${compantNameEng}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${compantNameEng}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="7" attributecolumnid="822">
                                        <rawdata>
                                            <value><![CDATA[${compantNameChi}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${compantNameChi}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="8" attributecolumnid="849">
                                        <rawdata>
                                            <value><![CDATA[${newPurchaserName}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${newPurchaserName}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="9" attributecolumnid="836">
                                        <rawdata>
                                            <value><![CDATA[]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="10" attributecolumnid="837">
                                        <rawdata>
                                            <value><![CDATA[]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="11" attributecolumnid="838">
                                        <rawdata>
                                            <value><![CDATA[]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="12" attributecolumnid="839">
                                        <rawdata>
                                            <value><![CDATA[]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="13" attributecolumnid="840">
                                        <rawdata>
                                            <value><![CDATA[${prepaymentAmount}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${prepaymentAmount}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="14" attributecolumnid="841">
                                        <rawdata>
                                            <value><![CDATA[${repaymentPercentage}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${repaymentPercentage}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="15" attributecolumnid="842">
                                        <rawdata>
                                            <value><![CDATA[${discount_percentage_}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${discount_percentage_}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="16" attributecolumnid="823">
                                        <rawdata>
                                            <value><![CDATA[${placeofincorporation}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${placeofincorporation}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="17" attributecolumnid="824">
                                        <rawdata>
                                            <value><![CDATA[${registeredAddress}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${registeredAddress}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="18" attributecolumnid="825">
                                        <rawdata>
                                            <value><![CDATA[${contactname}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${contactname}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="19" attributecolumnid="826">
                                        <rawdata>
                                            <value><![CDATA[${contactemailaddress}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${contactemailaddress}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="20" attributecolumnid="827">
                                        <rawdata>
                                            <value><![CDATA[${newSubcontractNo}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${newSubcontractNo}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="21" attributecolumnid="828">
                                        <rawdata>
                                            <value><![CDATA[${contractType}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${contractType}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="22" attributecolumnid="829">
                                        <rawdata>
                                            <value><![CDATA[${newProjectName}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${newProjectName}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="23" attributecolumnid="830">
                                        <rawdata>
                                            <value><![CDATA[${newprojectDetails}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${newprojectDetails}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="24" attributecolumnid="831">
                                        <rawdata>
                                            <value><![CDATA[${invoiceNo}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${invoiceNo}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="25" attributecolumnid="832">
                                        <rawdata>
                                            <value><![CDATA[${documentCertifyingNo}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${documentCertifyingNo}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="26" attributecolumnid="833">
                                        <rawdata>
                                            <value><![CDATA[${documentCertifyingIssuedby}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${documentCertifyingIssuedby}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="27" attributecolumnid="843">
                                        <rawdata>
                                            <value><![CDATA[${businessRegistrationNumber}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${businessRegistrationNumber}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="28" attributecolumnid="844">
                                        <rawdata>
                                            <value><![CDATA[${contactphonenumber}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${contactphonenumber}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="29" attributecolumnid="845">
                                        <rawdata>
                                            <value><![CDATA[${invoiceDate}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${invoiceDate}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="30" attributecolumnid="846">
                                        <rawdata>
                                            <value><![CDATA[${invoiceAmountHK}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${invoiceAmountHK}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="31" attributecolumnid="847">
                                        <rawdata>
                                            <value><![CDATA[${newCertifyingDate}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${newCertifyingDate}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="32" attributecolumnid="848">
                                        <rawdata>
                                            <value><![CDATA[${documentCertifyingAmountHK}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${documentCertifyingAmountHK}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="33" attributecolumnid="850">
                                        <rawdata>
                                            <value><![CDATA[]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="34" attributecolumnid="851">
                                        <rawdata>
                                            <value><![CDATA[]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="35" attributecolumnid="852">
                                        <rawdata>
                                            <value><![CDATA[${bankAccountNumber}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${bankAccountNumber}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="36" attributecolumnid="853">
                                        <rawdata>
                                            <value><![CDATA[${bankName}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${bankName}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="37" attributecolumnid="854">
                                        <rawdata>
                                            <value><![CDATA[${bankCode}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${bankCode}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="38" attributecolumnid="855">
                                        <rawdata>
                                            <value><![CDATA[${swift}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${swift}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="39" attributecolumnid="856">
                                        <rawdata>
                                            <value><![CDATA[${beneficiaryName}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${beneficiaryName}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="40" attributecolumnid="834">
                                        <rawdata>
                                            <value><![CDATA[${nameofDebtor}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${nameofDebtor}]]></value>
                                        </displaydata>
                                    </column>
                                    <column sequence="41" attributecolumnid="858">
                                        <rawdata>
                                            <value><![CDATA[${riverchainIDNo}]]></value>
                                        </rawdata>
                                        <displaydata>
                                            <value><![CDATA[${riverchainIDNo}]]></value>
                                        </displaydata>
                                    </column>
                              </item>
                          </data>
                          <sheettypeid>0</sheettypeid>
                          <enablesmartform>string</enablesmartform>
          <allowDeletedItemsView>string</allowDeletedItemsView>
          <allowAllColumnsInCustomView>string</allowAllColumnsInCustomView>
        </isheet>`;

      const postData = async () => {
        try {
          const res = await axios.post(`${API_URL}/post`, xmlData, {
            headers: {
              "Content-Type": "application/xml",
            },
          });
          console.log("Response_data:", res.data.progressivekey);

          const progressiveKey = res.data.progressivekey;
          // start here
          const response = await axios.post(
            `${BACKEND_URL}/getHighQResponse/${progressiveKey}`
          );
          console.log("Response_data_progresskey:", response.data);
          const msg = response.data?.[0]?.columns?.[0]?.message;

          // ✅ SAME single success logic
          setStatus(msg || "iSheet successfully generated");

          onUploadSuccess();
          setTimeout(() => {
            resetAll();
          }, 2000);
        } catch (error) {
          console.error("Error sending data:", error);
          setStatus("Error generating iSheet. Please try again.");
        } finally {
          setLoading(false);
          setFinalUpload(false); // 🔹 important: stop re-triggering this effect
        }
      };

      postData();
    }
  }, [finalUpload, errorCodeCC, product_type]);

  const handleFile1Change = (e) => {
    const selectedFile = e.target.files[0];
    console.log("selectedFile:", selectedFile);
    if (selectedFile) {
      setFile(selectedFile);
      setStatusCC(null);
    }
  };

  const isRemovingRef = useRef(false);
  const isRemovingRef2 = useRef(false);

  const removeFile = () => {
    isRemovingRef.current = true;
    setFile(null);
    setStatusCC(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  useEffect(() => {
    if (isRemovingRef.current) {
      isRemovingRef.current = false;
      return; // Skip status update when removing
    }

    if (file) {
      console.log("File:", file);
      handleUploadCC();
    }

    if (errorCodeCC === "ERROR") {
      setStatusCC("Upload failed validation error");
    } else if (errorCodeCC === "OK") {
      setStatusCC("");
    }
  }, [errorCodeCC, file]);

  const handleFile2Change = async (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    // store in state (for UI display)
    setFile2(file);

    // clear previous TF status / alerts if you want
    setStatusTF(null);
    setAlertMsg?.(null); // if you have this state

    // 🔥 Immediately verify this new file
    await handleUploadTFVerify(file);
  };

  const removeFile2 = () => {
    isRemovingRef2.current = true;
    setFile2(null);
    setStatusTF(null);
    setAlertMsg(null);
    hasVerifiedRef.current = false;

    if (fileInputRef2.current) {
      fileInputRef2.current.value = "";
    }
  };

  useEffect(() => {
    if (!file2) return;

    // prevent duplicate calls
    if (hasVerifiedRef.current) return;
    hasVerifiedRef.current = true;

    const processFile = async () => {
      // 1. verify upload
      const ptype = await handleUploadTFVerify();
      console.log("Verified product_type:", ptype);

      // 2. if product_A stop
      if (ptype === "product_A") {
        console.log("Product A detected — stopping after verification.");
        return;
      }

      // 3. if product_B show alert
      if (ptype === "product_B") {
        setAlertMsg("This is a product B");
        setAlertType("danger");
      }

      // 4. upload TF
      console.log("Not Product A — uploading TF...");
      await handleUploadTF();
    };

    processFile();
  }, [file2]);

  return (
    <>
      <h4
        style={{ textAlign: "center", marginBottom: "10px", marginTop: "30px" }}
      >
        Upload Client Card & Transaction File
      </h4>
      <hr />
      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Client Card (CC) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile1Change} ref={fileInputRef} />
      </div>

      {file && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            marginBottom: "20px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusCC && (
        <p
          style={{
            color: statusCC.includes("error")
              ? "#f44336"
              : statusCC.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "-20px",
            textAlign: "center",
          }}
        >
          {statusCC}
        </p>
      )}

      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Transaction File (TF) <span className="text-danger">*</span>
        </label>
        <br />
        <input
          key={fileInputKey2}
          type="file"
          onChange={handleFile2Change}
          ref={fileInputRef2}
        />
      </div>

      {file2 && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file2.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file2.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={() => {
              removeFile2();
              setAlertMsg(null);
            }}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {alertMsg && (
        <div className={`alert alert-${alertType} fade show`} role="alert">
          {alertMsg}
        </div>
      )}

      {statusTF && (
        <p
          style={{
            color:
              statusTF.includes("error") ||
              statusTF.toLowerCase().includes("This is a Product B file!")
                ? "#f44336"
                : statusTF.includes("successfully")
                ? "green"
                : "grey",
            marginTop: "5px",
            textAlign: "center",
          }}
        >
          {statusTF}
        </p>
      )}

      <button
        onClick={handleUpload}
        disabled={loading || alertMsg}
        className="btn btn-primary"
        style={{ marginTop: "30px" }}
      >
        {loading
          ? "Generating isheet"
          : loading === "error"
          ? "something wrong with the files"
          : "Generate iSheet"}
      </button>
      {status && (
        <p
          style={{
            backgroundColor: status.includes("error")
              ? "#7b1103"
              : status.includes("successfully")
              ? "green"
              : "grey",
            borderRadius: "10px",
            marginTop: "10px",
            padding: "10px",
            color: "#fff",
          }}
        >
          {status}
        </p>
      )}
    </>
  );
};

export default FileUpload;
